import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { combineReducers, createStore, compose } from "redux";

import App from "./App";
import restaurant from "./services/store/reducers/restaurant";
import user from "./services/store/reducers/user";
import versionReducer from "./services/store/reducers/version/index";
import cart from "./services/store/reducers/cart";
import settings from "./services/store/reducers/settings";
import config from "./services/store/reducers/config";
import notify from "./services/store/reducers/notify";
import productcategories from "./services/store/reducers/productcategories";

import "./AxiosInterceptor";

const composeEnhancers =
    (process.env.NODE_ENV === "development"
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : null || compose) || compose;

if (typeof process.argv[0] !== "undefined" && process.argv[0] == "clearapi") {
    localStorage.setItem("server_api", "");
}

const rootReducer = combineReducers({
    restaurant,
    user,
    cart,
    settings,
    config,
    productcategories,
    notify,
    versionReducer
});
const store = createStore(rootReducer, composeEnhancers());

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js